/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanySpaceMandatoryParams } from './CompanySpaceMandatoryParams';
import {
    CompanySpaceMandatoryParamsFromJSON,
    CompanySpaceMandatoryParamsFromJSONTyped,
    CompanySpaceMandatoryParamsToJSON,
} from './CompanySpaceMandatoryParams';

/**
 * Company space
 * @export
 * @interface CompanySpaceUpdateResponse
 */
export interface CompanySpaceUpdateResponse {
    /**
     * 
     * @type {number}
     * @memberof CompanySpaceUpdateResponse
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    user_content_creation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    domain_check: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanySpaceUpdateResponse
     */
    allowed_domains: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    domain_hard_check: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    email_check: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    email_hard_check: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    password_check: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    user_allowed_to_add_department: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    user_allowed_to_add_job_title: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    client_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    enable_external_ids: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    new_dashboard_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    user_content_activation: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    marketplace_url: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    supervisors: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    auto_content_upgrade: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    user_limit_enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanySpaceUpdateResponse
     */
    user_count_limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    multiple_workplaces_enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    workplace_tree_enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    subdomain: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    custom_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    app_url: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdateResponse
     */
    is_private: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    image_url: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    small_image_url: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    logo_picture_url: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdateResponse
     */
    small_logo_picture_url: string;
    /**
     * 
     * @type {CompanySpaceMandatoryParams}
     * @memberof CompanySpaceUpdateResponse
     */
    mandatory_params?: CompanySpaceMandatoryParams;
}

/**
 * Check if a given object implements the CompanySpaceUpdateResponse interface.
 */
export function instanceOfCompanySpaceUpdateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "user_content_creation" in value;
    isInstance = isInstance && "domain_check" in value;
    isInstance = isInstance && "allowed_domains" in value;
    isInstance = isInstance && "domain_hard_check" in value;
    isInstance = isInstance && "email_check" in value;
    isInstance = isInstance && "email_hard_check" in value;
    isInstance = isInstance && "password_check" in value;
    isInstance = isInstance && "user_allowed_to_add_department" in value;
    isInstance = isInstance && "user_allowed_to_add_job_title" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "enable_external_ids" in value;
    isInstance = isInstance && "new_dashboard_on" in value;
    isInstance = isInstance && "user_content_activation" in value;
    isInstance = isInstance && "marketplace_url" in value;
    isInstance = isInstance && "supervisors" in value;
    isInstance = isInstance && "auto_content_upgrade" in value;
    isInstance = isInstance && "user_limit_enabled" in value;
    isInstance = isInstance && "user_count_limit" in value;
    isInstance = isInstance && "multiple_workplaces_enabled" in value;
    isInstance = isInstance && "workplace_tree_enabled" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "subdomain" in value;
    isInstance = isInstance && "app_url" in value;
    isInstance = isInstance && "is_private" in value;
    isInstance = isInstance && "image_url" in value;
    isInstance = isInstance && "small_image_url" in value;
    isInstance = isInstance && "language" in value;
    isInstance = isInstance && "logo_picture_url" in value;
    isInstance = isInstance && "small_logo_picture_url" in value;

    return isInstance;
}

export function CompanySpaceUpdateResponseFromJSON(json: any): CompanySpaceUpdateResponse {
    return CompanySpaceUpdateResponseFromJSONTyped(json, false);
}

export function CompanySpaceUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySpaceUpdateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_content_creation': json['user_content_creation'],
        'domain_check': json['domain_check'],
        'allowed_domains': json['allowed_domains'],
        'domain_hard_check': json['domain_hard_check'],
        'email_check': json['email_check'],
        'email_hard_check': json['email_hard_check'],
        'password_check': json['password_check'],
        'user_allowed_to_add_department': json['user_allowed_to_add_department'],
        'user_allowed_to_add_job_title': json['user_allowed_to_add_job_title'],
        'client_id': json['client_id'],
        'enable_external_ids': json['enable_external_ids'],
        'new_dashboard_on': json['new_dashboard_on'],
        'user_content_activation': json['user_content_activation'],
        'marketplace_url': json['marketplace_url'],
        'supervisors': json['supervisors'],
        'auto_content_upgrade': json['auto_content_upgrade'],
        'user_limit_enabled': json['user_limit_enabled'],
        'user_count_limit': json['user_count_limit'],
        'multiple_workplaces_enabled': json['multiple_workplaces_enabled'],
        'workplace_tree_enabled': json['workplace_tree_enabled'],
        'name': json['name'],
        'subdomain': json['subdomain'],
        'custom_domain': !exists(json, 'custom_domain') ? undefined : json['custom_domain'],
        'app_url': json['app_url'],
        'is_private': json['is_private'],
        'image_url': json['image_url'],
        'small_image_url': json['small_image_url'],
        'language': json['language'],
        'logo_picture_url': json['logo_picture_url'],
        'small_logo_picture_url': json['small_logo_picture_url'],
        'mandatory_params': !exists(json, 'mandatory_params') ? undefined : CompanySpaceMandatoryParamsFromJSON(json['mandatory_params']),
    };
}

export function CompanySpaceUpdateResponseToJSON(value?: CompanySpaceUpdateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_content_creation': value.user_content_creation,
        'domain_check': value.domain_check,
        'allowed_domains': value.allowed_domains,
        'domain_hard_check': value.domain_hard_check,
        'email_check': value.email_check,
        'email_hard_check': value.email_hard_check,
        'password_check': value.password_check,
        'user_allowed_to_add_department': value.user_allowed_to_add_department,
        'user_allowed_to_add_job_title': value.user_allowed_to_add_job_title,
        'client_id': value.client_id,
        'enable_external_ids': value.enable_external_ids,
        'new_dashboard_on': value.new_dashboard_on,
        'user_content_activation': value.user_content_activation,
        'marketplace_url': value.marketplace_url,
        'supervisors': value.supervisors,
        'auto_content_upgrade': value.auto_content_upgrade,
        'user_limit_enabled': value.user_limit_enabled,
        'user_count_limit': value.user_count_limit,
        'multiple_workplaces_enabled': value.multiple_workplaces_enabled,
        'workplace_tree_enabled': value.workplace_tree_enabled,
        'name': value.name,
        'subdomain': value.subdomain,
        'custom_domain': value.custom_domain,
        'app_url': value.app_url,
        'is_private': value.is_private,
        'image_url': value.image_url,
        'small_image_url': value.small_image_url,
        'language': value.language,
        'logo_picture_url': value.logo_picture_url,
        'small_logo_picture_url': value.small_logo_picture_url,
        'mandatory_params': CompanySpaceMandatoryParamsToJSON(value.mandatory_params),
    };
}

